/**
 * Created by guest076 on 4/20/2015.
 */
angular.module("iFAST.loginError")
    .factory("ssoErrorService", function() {
        "use strict";
        var ssoErrorMsgs = {
            "slf": {
                "en": "We're sorry. You cannot access this site at this time. We apologize for the inconvenience. For assistance, please contact the Sun Life Guaranteed Investment Funds (GIFs) Client Services Team at 1-844-753-4437.",
                "fr": "Nous sommes désolés. Vous ne pouvez pas accéder au site pour l'instant. Nous vous prions de nous excuser de ces inconvénients. Pour obtenir de l'aide, veuillez communiquer avec l'équipe de service à la clientèle chargée des Fonds de placement garanti (FPG) Financière Sun Life au 1-844-374-1375."},
            "mmf": {
                "en": "We are unable to authenticate your account.  Please verify your credentials and call an administrator for help at 1-888-588-7999.",
                "fr": "Nous sommes incapables d'authentifier votre compte. Se il vous plaît vérifier vos informations d'identification et appeler un administrateur de l'aide au 1-877-426-9991."},
            "default": {"en": "Login failed.", "fr": "Échec de la connexion."}
        };

        var getError = function(clientCd, langCd) {
            var msgs = ssoErrorMsgs[clientCd];
            var msg = (msgs)? msgs[langCd] : ssoErrorMsgs["default"][langCd];
            return msg;
        };

        return {
            getError: getError
        };

    });
	
	
	


// WEBPACK FOOTER //
// ./WebContent/src/login/sso-error-service.js